import { FLUSH_ALL_MESSAGES } from 'ACTIONS';

export const flushAllMessages = () => (dispatch) => {
    dispatch({ type: FLUSH_ALL_MESSAGES });
};
